import r from "../managers/braze-instance.js";
import e from "./banner-provider.js";
var i = {
  i: !1,
  provider: null,
  o: function o() {
    return i.t(), i.provider || (i.provider = new e(r.l(), r.m(), r.p(), r.u()), r.v(i.provider)), i.provider;
  },
  t: function t() {
    i.i || (r.g(i), i.i = !0);
  },
  destroy: function destroy() {
    i.provider = null, i.i = !1;
  }
};
export default i;